<template>
  <div class="permissionSet">
    <!-- 三个按钮 -->
    <el-radio-group v-model="tabPosition" style="margin-bottom: 30px">
      <el-radio-button label="1">管理组</el-radio-button>
      <el-radio-button label="2">管理员管理</el-radio-button>
      <el-radio-button label="3">操作日志</el-radio-button>
    </el-radio-group>
    <!-- 管理组 -->
    <div v-show="tabPosition == 1" class="team">
      <!-- 左侧 -->
      <el-card v-show="admincheck" shadow="never" class="team_left">
        <el-button class="addbtn" type="primary" round @click="admincheck = false">添加管理组</el-button>
        <div class="d1">
          <p class="fz16">系统组</p>
          <p
            @click="pick = 1"
            class="color999"
            :class="{ colorBlue: pick == 1 }"
          >
            <span>超级管理组</span><span>10</span>
          </p>
        </div>
        <div class="d2">
          <p class="fz16">自定义管理组</p>
          <p
            @click="pick = 2"
            class="color999"
            :class="{ colorBlue: pick == 2 }"
          >
            <span>项目部</span><span>10</span>
          </p>
          <p
            @click="pick = 3"
            class="color999"
            :class="{ colorBlue: pick == 3 }"
          >
            <span>技术部</span><span>10</span>
          </p>
          <p
            @click="pick = 4"
            class="color999"
            :class="{ colorBlue: pick == 4 }"
          >
            <span>市场部</span><span>10</span>
          </p>
          <p
            @click="pick = 5"
            class="color999"
            :class="{ colorBlue: pick == 5 }"
          >
            <span>人事部</span><span>10</span>
          </p>
        </div>
      </el-card>
      <!-- 右侧超级管理组 -->
      <div v-if="pick == 1" class="team_right">
        <el-card class="card2" shadow="never">
          <p class="p1">
            <span class="s1">超级管理组</span
            ><span class="s2"
              >管理全企业成员，可查看所有成员数据，使用全部功能</span
            ><span @click="edit" class="s3"  v-if="is"
              >编辑<i
             
                class="el-icon-edit"
                style="font-size: 18px; margin-left: 5px"
              ></i
            ></span>
            <span @click="edit" class="s4"   v-if="pick != 1"
              >删除<i
                class="el-icon-delete"
                style="font-size: 18px; margin-left: 5px"
              ></i
            ></span>
          </p>
          <p class="p2">
            <span class="s1">管理员名称：</span>
            <span class="s2" v-if="is">超级管理组</span>
            <el-input class="guanliyuan" v-if="!is" v-model="input1" placeholder="请输入内容"></el-input>
          </p>
          <p class="p3"><span class="s1">管理员列表：</span>
          
          <ul>
            <span v-if="!is"  class="s3"
              @click="dialogFormVisible = true">编辑<i
                class="el-icon-edit"
                style="font-size: 18px; margin-left: 5px"
              ></i
            ></span>
              <ul>
              <li ><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
          </ul></ul>
          </p>
          <p class="p4"><span class="s1">功能权限：</span>
          <el-tree
          ref="tree"
          default-expand-all
            :data="data"
            show-checkbox
            node-key="id"
            :default-expanded-keys="[2, 3]"
            :default-checked-keys="[2,3]"
            :props="defaultProps">
            </el-tree>
          </p>
        </el-card>
        <el-card shadow="never" class="card3">
           <div v-if="!is">
             <el-button plain round @click="is = true;admincheck = true">取消</el-button>
           <el-button type="primary" round @click="is = true;admincheck = true">确定</el-button>
           </div>
        </el-card>
      </div>
      <!-- 右侧自定义组 -->
       <div v-if="pick != 1" class="team_right">
        <el-card class="card2" shadow="never">
          <p class="p1">
            <span class="s1">项目部</span
            ><span class="s2"
              >管理全企业成员，可查看所有成员数据，使用全部功能</span
            ><span @click="edit" class="s3"  v-if="is"
              >编辑<i
             
                class="el-icon-edit"
                style="font-size: 18px; margin-left: 5px"
              ></i
            ></span>
            <span @click="edit" class="s4"  v-if="!is"
              >删除<i
                class="el-icon-delete"
                style="font-size: 18px; margin-left: 5px"
              ></i
            ></span>
          </p>
          <p class="p2">
            <span class="s1">管理员名称：</span>
            <span class="s2" v-if="is">项目部</span>
            <el-input class="guanliyuan" v-if="!is" v-model="input1" placeholder="请输入内容"></el-input>
          </p>
          <p class="p3"><span class="s1">管理员列表：</span>
          
          <ul>
            <span v-if="!is"  class="s3"
              @click="dialogFormVisible = true">编辑<i
                class="el-icon-edit"
                style="font-size: 18px; margin-left: 5px"
              ></i
            ></span>
              <ul>
              <li ><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
              <li><img style="width:32px;" src="../../assets/images/ticons/Slice 2@2x.png" alt=""><span>吴彦祖</span></li>
          </ul></ul>
          </p>
          <p class="p4"><span class="s1">功能权限：</span>
          <el-tree
          ref="tree"
          default-expand-all
            :data="data"
            show-checkbox
            node-key="id"
            :default-expanded-keys="[2, 3]"
            :default-checked-keys="[1-1]"
            :props="defaultProps">
            </el-tree>
          </p>
        </el-card>
        <el-card shadow="never" class="card3">
           <div v-if="!is">
             <el-button plain round @click="is = true">取消</el-button>
           <el-button type="primary" round @click="is = true">确定</el-button>
           </div>
        </el-card>
      </div>
    </div>
    <!-- 管理员管理 -->
    <admin  v-if="tabPosition == 2" />
    <!-- 操作日志 -->
    <operation  v-show="tabPosition == 3" />
    <!-- 弹出框 -->
    <el-dialog title="添加成员" :visible.sync="dialogFormVisible">
        <div class="main">
            <div class="left">
                <!-- 搜索框 -->
                <el-input
                    placeholder="请输入关键词搜索标签"
                    suffix-icon="el-icon-search"
                    v-model="search">
                </el-input>
                <!-- 名字区域 -->
                <ul>
                    <li @click="tans(item)" :class="{active:item.check}" v-for="(item,index) in tans1" :key="index">
                        <div class="d1"><img style="width:24px;margin-right:8px;" src="../../assets/images/newIcon/ai_IP_icon.png" alt=""><span>{{item.name}}</span></div>
                        <div class="d2"><i :class="{'el-icon-check':item.check}"></i></div>
                    </li>
                    
                </ul>
                     <!-- 分页 -->
                     <el-pagination
                        layout="prev, pager, next"
                        :total="80">
                    </el-pagination>             
            </div>
            <div class="right">
                <p>已选择成员</p>
                <ul>
                  <template v-for="(item,index) in tans1" >
                     <li  class="active" v-if="item.check" >
                        <div class="d1"><img style="width:24px;margin-right:8px;" src="../../assets/images/newIcon/ai_IP_icon.png" alt=""><span>{{item.name}}</span></div>
                        <div class="d2"><i @click="item.check = !item.check" class="el-icon-close"></i></div>
                    </li>
                  </template>
                </ul>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import admin from "./components/permissionCom/admin.vue";
import operation from "./components/permissionCom/operation.vue";
export default {
  components: {
    admin,
    operation,
  },
  data() {
    return {
      //点击添加管理组
      admincheck: true,
      //弹框数组渲染数据
      tans1: [
        { name: "唐骏套", check: true, id: 1 },
        { name: "邱建好", check: false, id: 2 },
        { name: "邱建好", check: false, id: 3 },
        { name: "邱建好", check: false, id: 4 },
        { name: "邱建好", check: false, id: 5 },
      ],
      tans2: [],
      //管理员输入
      input1: "",
      //搜索框内容
      search: "",
      //弹框控制
      dialogFormVisible: false,
      //控制树形禁用
      is: true,
      // 控制顶部3个按钮切换
      tabPosition: "1",
      //左侧系统组或自定义组选中状态
      pick: 1,
      //树形控件
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  created() {
    //点击取消跳回管理员设置
    if (this.$route.query.t) {
      this.tabPosition = this.$route.query.t;
      //刷新路径 解决一直有t
      this.$router.push({ name: "permissionSet" });
    }
  },
  computed: {
    data() {
      return [
        {
          id: 1,
          label: "工作台",
          disabled: this.is,
          children: [
            {
              id: 1 - 1,
              label: "数据概览",
              disabled: this.is,
              children: [
                {
                  id: 2,
                  label: "会员数据",
                  disabled: this.is,
                },
                {
                  id: 3,
                  label: "营销数据",
                  disabled: this.is,
                },
              ],
            },
            {
              id: 1 - 2,
              label: "智能分析",
              disabled: this.is,
              children: [
                {
                  id: 1 - 2 - 1,
                  label: "积木云助手",
                  disabled: this.is,
                },
              ],
            },
          ],
        },
        {
          id: 1 - 3,
          label: "会员中台",
          disabled: this.is,
          children: [
            {
              id: 1 - 3 - 1,
              label: "会员管理",
              disabled: this.is,
              children: [
                {
                  id: 1 - 3 - 1 - 1,
                  label: "会员列表",
                  disabled: this.is,
                },
                {
                  id: 1 - 3 - 1 - 2,
                  label: "会员群组",
                  disabled: this.is,
                },
                {
                  id: 1 - 3 - 1 - 3,
                  label: "会员导入",
                  disabled: this.is,
                },
              ],
            },
            {
              id: 1 - 3 - 2,
              label: "会员画像",
              disabled: this.is,
              children: [
                {
                  id: 1 - 3 - 2 - 1,
                  label: "标签管理",
                  disabled: this.is,
                },
              ],
            },
            {
              id: 1 - 3 - 3,
              label: "渠道管理",
              disabled: this.is,
              children: [
                {
                  id: 1 - 3 - 3 - 1,
                  label: "渠道列表",
                  disabled: this.is,
                },
              ],
            },
          ],
        },
        {
          id: 1 - 3 - 4,
          label: "会员分析",
          disabled: this.is,
          children: [
            {
              id: 1 - 3 - 4 - 1,
              label: "会员画像",
              disabled: this.is,
              children: [
                {
                  id: 1 - 3 - 4 - 1 - 1,
                  label: "会员画像",
                  disabled: this.is,
                },
                {
                  id: 1 - 3 - 4 - 1 - 2,
                  label: "AARR分析",
                  disabled: this.is,
                },
              ],
            },
            {
              id: 1 - 3 - 4 - 2,
              label: "lTV分析",
              disabled: this.is,
              children: [
                {
                  id: 1 - 3 - 4 - 2 - 1,
                  label: "会员生命周期",
                  disabled: this.is,
                },
              ],
            },
            {
              id: 1 - 3 - 4 - 3,
              label: "微信生态分析",
              disabled: this.is,
              children: [
                {
                  id: 1 - 3 - 4 - 3 - 1,
                  label: "公众号分析",
                  disabled: this.is,
                },
                {
                  id: 1 - 3 - 4 - 3 - 2,
                  label: "粉丝转化",
                  disabled: this.is,
                },
                {
                  id: 1 - 3 - 4 - 3 - 3,
                  label: "粉丝资产",
                  disabled: this.is,
                },
              ],
            },
            {
              id: 1 - 3 - 4 - 4,
              label: "数字化事件",
              disabled: this.is,
              children: [
                {
                  id: 1 - 3 - 4 - 4 - 1,
                  label: "会员事件",
                  disabled: this.is,
                },
              ],
            },
          ],
        },
      ];
    },
  },
  methods: {
    //弹框内点击名字事件
    tans(item) {
      item.check = true;
      this.tans2.forEach((i) => {
        if (i.id == item.id) {
          return;
        } else {
          this.tans2.push(item);
        }
      });
    },
    //点编辑切换选用禁用
    edit() {
      this.is = !this.is;
      if (!this.is) {
        this.$refs.tree.$el.style.color = "#333";
      } else {
        this.$refs.tree.$el.style.color = "#999";
      }
    },
  },
};
</script>

<style lang='less' scoped>
.permissionSet {
  padding: 20px;
  //修改树形结构禁用颜色
  /deep/ .el-checkbox__input.is-disabled.is-indeterminate .el-checkbox__inner {
    background-color: #98beff;
    border-color: #dcdfe6;
  }
  /deep/.el-checkbox__input.is-disabled.is-indeterminate .el-checkbox__inner::before {
    background-color: #fff;
    border-color: #fff;
  }
  /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #98beff;
    border-color: #dcdfe6;
  }
  /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #fff;
  }
  /deep/ .el-radio-button:first-child .el-radio-button__inner {
    width: 92px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 18px 0 0 18px;
  }
  /deep/ .el-radio-button .el-radio-button__inner {
    width: 92px;
    height: 36px;
    line-height: 36px;
    text-align: center;
  }
  /deep/ .el-radio-button:last-child .el-radio-button__inner {
    width: 92px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 0 18px 18px 0;
  }
  //管理组
  .team {
    display: flex;
    //BUG修改
    .guanliyuan {
      width: 424px;
      height: 32px;
      margin-left: 15px;
      /deep/ .el-input__inner {
        background: #f6f6f6;
        border-radius: 15px;
      }
    }
    .team_left {
      width: 247px;
      /deep/ .el-card__body {
        padding: 0px;
      }
      .addbtn {
        width: 170px;
        height: 46px;
        border-radius: 23px;
        margin-top: 20px;
        margin-left: 40px;
        font-size: 16px;
      }
      .fz16 {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #33393f;
        margin-left: 20px;
      }

      .color999 {
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        height: 39px;
        margin-top: 10px;
        padding-left: 40px;
        padding-right: 20px;
        line-height: 39px;
        display: flex;
        justify-content: space-between;
        background-color: #fff;
        color: #999999;
      }
      .colorBlue {
        color: #327eff;
        background: #e5f4ff;
      }
      .d1 {
        margin-top: 10px;
      }
      .d2 {
        margin-top: 20px;
      }
    }
    .team_right {
      flex: 1;
      /deep/ .el-tree-node__label {
        font-size: 12px;
      }
      .card2 {
        /deep/ .el-card__body {
          padding-right: 210px;
        }
      }

      .p1 {
        .s1 {
          font-size: 16px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #33393f;
        }
        .s2 {
          margin-left: 12px;
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #777777;
        }
        .s3 {
          margin-left: 20px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #0091ff;
        }
        .s4 {
          margin-left: 20px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #eb5757ff;
        }
      }
      .p2 {
        margin-top: 29px;
        .s1 {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
        .s2 {
          margin-left: 4px;
          font-size: 16px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
      }
      .p3 {
        margin-top: 23px;
        display: flex;
        .s1 {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          white-space: nowrap;
        }
        .s3 {
          display: block;
          margin-left: 20px;
          margin-bottom: 10px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #0091ff;
        }
        ul {
          display: flex;
          flex-wrap: wrap;
          li {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            margin-left: 11px;
            margin-bottom: 10px;
            color: #327eff;
            font-size: 12px;
            width: 86px;
            height: 32px;
            border-radius: 16px;
            overflow: hidden;
            background: rgba(0, 145, 255, 0.10082495957612991);
          }
        }
      }
      .p4 {
        display: flex;
        .s1 {
          margin-left: 20px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          white-space: nowrap;
        }
        .el-tree {
          color: #999;
        }
      }
    }
  }
  //弹框内样式
  /deep/ .el-dialog {
    width: 880px;
    .main {
      width: 880px;
      height: 480px;
      display: flex;
      .left,
      .right {
        box-sizing: border-box;
        padding: 18px 22px;
        flex: 1;
        border-right: 1px solid #e6e6e6;
        position: relative;
        > ul {
          margin-top: 28px;
          li {
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .d1 {
              display: flex;
            }
            .d2 {
              margin-right: 20px;
            }
          }
          .active {
            color: #327eff;
          }
        }
        //分页
        .el-pagination {
          position: absolute;
          // margin-right: 50px;
          right: 0;
          bottom: 0;
        }
      }
      .right {
        box-sizing: border-box;
        flex: 1;
        > p {
          font-size: 16px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(37, 45, 61, 0.8500000238418579);
          transform: translate(0px, 15px);
        }
        ul {
          margin-top: 38px;
        }
      }
    }
  }
  .card3 {
    /deep/ .el-card__body {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>